import '../sass/text-cards.scss';

(() => {
    const swiperScript = document.querySelector('#icrav-2027-swiper-js');
    const $blocks = document.querySelectorAll('.text-cards');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.text-cards__carousel');
        const $carouselNavigations = $block.querySelectorAll('.text-cards__navigation');
        const $carouselPaginationTop = $block.querySelector('.text-cards__pagination--top');
        const $carouselPaginationBottom = $block.querySelector('.text-cards__pagination--bottom');
        const $carouselNavigationPrev = $block.querySelectorAll('.text-cards__navigation-btn--prev');
        const $carouselNavigationNext = $block.querySelectorAll('.text-cards__navigation-btn--next');

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                pagination: {
                    el: $carouselPaginationTop,
                    clickable: false,
                },
                keyboard: {
                    enabled: true,
                },
            });
            
            const toggleControls = () => {
                if (carousel.isBeginning && carousel.isEnd) {
                    $carouselNavigations.forEach($carouselNavigation => {
                        $carouselNavigation.classList.add('text-cards__navigation--hidden');
                    });
                } else {
                    $carouselNavigations.forEach($carouselNavigation => {
                        $carouselNavigation.classList.remove('text-cards__navigation--hidden');
                    });
                }
            };

            const toggleNavigationBtns = () => {
                if ($carouselNavigationPrev) {
                    if (carousel.isBeginning) {
                        $carouselNavigationPrev.forEach($button => {
                            $button.classList.add('text-cards__navigation-btn--disabled');
                            $button.disabled = true;
                        });
                    } else {
                        $carouselNavigationPrev.forEach($button => {
                            $button.classList.remove('text-cards__navigation-btn--disabled');
                            $button.disabled = false;
                        });
                    }
                }

                if ($carouselNavigationNext) {
                    if (carousel.isEnd) {
                        $carouselNavigationNext.forEach($button => {
                            $button.classList.add('text-cards__navigation-btn--disabled');
                            $button.disabled = true;
                        });
                    } else {
                        $carouselNavigationNext.forEach($button => {
                            $button.classList.remove('text-cards__navigation-btn--disabled');
                            $button.disabled = false;
                        });
                    }
                }
            };

            carousel.on('slideChange', () => {
                if ($carouselPaginationBottom) {
                    $carouselPaginationBottom.querySelectorAll('.swiper-pagination-bullet').forEach($bullet => {
                        $bullet.classList.remove('swiper-pagination-bullet-active');
                    });

                    $carouselPaginationBottom.querySelectorAll('.swiper-pagination-bullet')[carousel.realIndex].classList.add('swiper-pagination-bullet-active');
                }

                toggleNavigationBtns();
            });

            carousel.on('resize', () => {
                toggleControls();
            });

            if ($carouselNavigationPrev) {
                $carouselNavigationPrev.forEach($button => {
                    $button.addEventListener('click', () => {
                        carousel.slidePrev();
                    });
                });
            }

            if ($carouselNavigationNext) {
                $carouselNavigationNext.forEach($button => {
                    $button.addEventListener('click', () => {
                        carousel.slideNext();
                    });
                });
            }

            toggleNavigationBtns();
            toggleControls();
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#icrav-2027-swiper-js');

                console.log(swiperScript);

                if (!swiperScript) return;

                initCarousel();
            });
        }
    });
})();
